import DeleteIcon from '@mui/icons-material/Delete';
import { Box, ButtonBase, IconButton, Typography } from '@mui/material';
import { type Project } from '@ocode/domain';
import clsx from 'clsx';
import React from 'react';
import { BbsDatetimeBox } from './BbsDatetimeBox';
import { GalleryListBreedTag } from './GalleryListBreedTag';

interface Props {
  seq: number;
  project: Project;
  onClick: React.MouseEventHandler;
  onClickDelete?: React.MouseEventHandler;
}

// js와 py는 썸네일이 없으므로 이미지 위치에 아이콘을 표시
const THUMBNAILS: Record<string, string> = {
  js: '/_static/images/ic_javascript.png',
  py: '/_static/images/ic_python.png',
  p5: '/_static/images/ic_p5js.png', // p5js는 썸네일이 있어서 이 아이콘은 사용되지 않는다.
};

export function ProjectListRow(props: Props) {
  const { seq, project, onClick, onClickDelete } = props;
  const { projectId, breed, projectName, thumbUrl, memo, changeTimestamp } = project;

  return (
    <ButtonBase
      className="ProjectListRow-root"
      component="div"
      disableRipple
      onClick={onClick}
      sx={{
        display: 'flex',
        alignItems: 'center',
        minHeight: 64,
        py: 1,
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.05)',
          '& .ProjectListRow-title': {
            color: 'primary.main',
          },
        },
      }}
    >
      <Typography sx={{ minWidth: 54, textAlign: 'right', pr: 3, color: '#888' }}>{seq}</Typography>
      <Box
        className={clsx({
          hasThumb: !!thumbUrl,
        })}
        sx={{
          '& img': {
            width: 130,
            height: 91,
            borderRadius: '10px',
            objectFit: 'cover',
            border: '1px solid #ddd',
          },
          '&.hasThumb img': {
            borderRadius: '10px',
            objectFit: 'cover',
            border: '1px solid #ddd',
          },
        }}
      >
        <img src={thumbUrl ?? THUMBNAILS[breed]} width={64} height={64} alt="" />
      </Box>
      <Box sx={{ ml: 2, flex: 1 }}>
        <GalleryListBreedTag breed={breed} />
        <Typography
          className="ProjectListRow-title"
          variant="body1"
          sx={{
            mt: 0.5,
            color: '#222',
            fontWeight: 700,
            width: '90%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {projectName}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            mt: 0.5,
            color: '#888',
            width: '90%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          }}
        >
          {memo}
        </Typography>
      </Box>
      <BbsDatetimeBox datetime={changeTimestamp} alignment="right" vertical />
      {onClickDelete && (
        <Box sx={{ px: 2 }}>
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              onClickDelete(e);
            }}
          >
            <DeleteIcon />
          </IconButton>
        </Box>
      )}
    </ButtonBase>
  );
}
